var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.is_last)?_c('div',{staticClass:"container"},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"icon",attrs:{"src":_vm.src}})]):_c('div',{staticClass:"container-nomore"},[_c('div',[_vm._v(_vm._s(_vm.$t('LoadMore.no_more')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }